(() => {
  document.querySelectorAll('[data-bk-restock-contact]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    const scope = root.closest('.shopify-section') || document;
    const variantField = root.querySelector('[data-restock-variant]');
    function sync() {
      const id = scope.querySelector('product-form form [name="id"]')?.value;
      const variant = variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      root.hidden = variant.available;
      if (!variantField) return; // Native successful submission remains a confirmation message.
      variantField.value = String(variant.id);
      root.querySelector('[data-restock-variant-title]').value = variant.title;
      const url = new URL(root.dataset.url); url.searchParams.set('variant', String(variant.id));
      root.querySelector('[data-restock-url]').value = url.href;
      root.querySelector('[data-restock-body]').value = `Beaver Post — manual restock request. Please email me when this exact item is back in stock. Variant: ${variant.title} (${variant.id}). Language: ${root.dataset.locale}. ${url.href}`;
    }
    sync(); const timer = setInterval(sync, 750);
    window.addEventListener('pagehide', () => clearInterval(timer), { once: true });
    // Keep Shopify's native submission and spam protection intact; never simulate success.
  });
})();
